import { forwardRef, RefCallback } from 'react'
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'

import { ChartInstance } from 'common/components/AutoResizeChart'

import 'highcharts/highcharts-more'
import 'highcharts/modules/no-data-to-display'

import ChartContainer from './ChartContainer'
import type { SentimentAnalysisChartVariables } from './getSentimentAnalysisChartOptions'
import { getSentimentAnalysisChartOptions } from './getSentimentAnalysisChartOptions'

type Props = SentimentAnalysisChartVariables & {
  isLoading: boolean
  ref?: RefCallback<ChartInstance>
}

const SentimentAnalysisChart = forwardRef<ChartInstance, Props>(
  ({ selectedSentiment, series, onClickSentiment, isLoading }, ref) => {
    const chartOptions = getSentimentAnalysisChartOptions({
      series,
      selectedSentiment,
      onClickSentiment,
    })

    return (
      <ChartContainer isLoading={isLoading}>
        <HighchartsReact
          highcharts={Highcharts}
          options={chartOptions}
          ref={ref}
          immutable={false}
        />
      </ChartContainer>
    )
  }
)

export default SentimentAnalysisChart
